import React from 'react';
import { SuperEmojiCollection } from '../../utils/types';
import { SUPER_EMOJIS } from '../../services/superEmojiService';

export interface GameHeaderProps {
  progress: number;
  superEmojiCollection: SuperEmojiCollection;
  onSuperEmojiClick: (emoji: string) => void;
  level?: number;
  isAutoMode?: boolean;
  emojiMode?: boolean; // NEW: Flag for emoji rescue mode
}

const GameHeader: React.FC<GameHeaderProps> = ({ 
  progress,
  superEmojiCollection,
  onSuperEmojiClick,
  level,
  isAutoMode,
  emojiMode = true
}) => {
  return (
    <div className="game-header">
      <div className="progress-bar-in-header">
        <div 
          className="progress-fill" 
          style={{ width: `${progress * 100}%` }} 
        />
      </div>
    </div>
  );
};

export default GameHeader;